export default "__VITE_ASSET__DUALA0ij__"